$(document).ready(function () {
    let x = new ModuleSearchTypeahead();
});

export interface ISearchPredictorResult {
    id: number;
    searchContext: string;
    searchString: string;
    searchCount: number;
    searchResultsCount: number;
    firstSearchDateTime: string;
    lastSearchDateTime: string;
    appendedSearchString: string;
}

export class ModuleSearchTypeahead {

    private _initialised: boolean = false;    
  
    constructor(
        private _url: string = "/SearchPredictor/GetValuesAsObjects/"
    ) {        
        this.init();
    }

    private init = () => {
        if (this._initialised) {
            return;
        }

        $("#btnClear").click(function (e) {            
            window.location.href = window.location.pathname;
            //$("input[data-module-search-context]").each(function () {
            //    $(this).val('');
            //});   

            //$(".hbsmrSelectPicker").each(function (e) {     
            //    $(this).val('');
            //    (<any>$(this)).selectpicker("refresh");        
            //});             
        });

        $(".btn-clear-select").click(function (e) {
            let target = $(this).data("bs-target");
            (<any>$(target)).selectpicker("val", "");
        });
         

        this.addTypeaheads();
        this._initialised = true;
    }

    private addTypeaheads = (): void => {
        let self = this;

        //get all the input with data-module-search-context
        $("input[data-module-search-context]").each(function () {
            self.initialiseTypeahead($(this));
        });     
    }
    
    private initialiseTypeahead = (ele: JQuery<HTMLElement>): void => {
        let self = this;
        let url = `${self._url}${ele.data("moduleSearchContext")}`;
        
        // need to kill any pre-existing suggestions        
        ele.typeahead("destroy");
                
        ele.typeahead({
            displayText: function (item: any) {   
                let e = <ISearchPredictorResult>item;
                return `${item.searchString}`;
            },
            minLength: 2,
            delay: 1,
            items: 100,
            source: function (query, process) {
                $.ajax({
                    url: url,
                    data: { query: query },
                    dataType: 'json'
                }).done(function (response) {
                    return process(response);
                });
            },
            autoSelect: false,
            changeInputOnSelect: false,
            afterSelect: function (item) {
                let e = <ISearchPredictorResult>item;
                this.$element.val(e.searchString);
            }
        });
    }
}

